import React, {useEffect, useState} from 'react';
import Sticky from 'react-stickynode';
import {ThemeProvider} from 'styled-components';
import {lightTheme, darkTheme, GlobalStyles} from './reset-css';
import ScrollToTop from 'react-scroll-up';
import Navbar from './navbar/navbar';
import Footer from './footer/footer';
import ScrollUpButton from './scroll-up-button/scroll-up-button';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3'


type LayoutProps = {
    children: React.ReactNode;
    do_sticky?: boolean;
    do_footy?: boolean;
    do_recaptcha?: boolean;
};

const RecaptchaWrapper: React.FunctionComponent<LayoutProps> = ({
                                                          children,
                                                          do_recaptcha = false,
                                                      }) => {
    const recaptcha_key = process.env.RECAPTCHAV3_SITE_KEY ?? "";
    return (
        do_recaptcha
            ? <GoogleReCaptchaProvider reCaptchaKey={recaptcha_key ?? ""}>{children}</GoogleReCaptchaProvider>
            : <>{children}</>
    );
}

const Layout: React.FunctionComponent<LayoutProps> = ({
                                                          children,
                                                          do_sticky = true,
                                                          do_footy = true,
                                                          do_recaptcha = false,
                                                      }) => {
    const [theme, setTheme] = useState("light");
    const [isTransitionEnabled, setIsTransitionEnabled] = useState(false);
    const [isCodeWrapEnabled, setIsCodeWrapEnabled] = useState(false);

    const isDarkTheme = theme === "dark";
    const toggleTheme = () => {
        const updatedTheme = isDarkTheme ? "light" : "dark";
        setTheme(updatedTheme);
        localStorage.setItem("theme", updatedTheme);
        setIsTransitionEnabled(true);
        toggleWrap();
    };

    const toggleWrap = () => {
        setIsCodeWrapEnabled(prevState => !prevState)
        const codeWrapping = isCodeWrapEnabled ? "wrap" : "no-wrap";
        localStorage.setItem("code-wrapping", codeWrapping);
    }

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme");

        const prefersDark = window.matchMedia &&
            window.matchMedia('(prefers-color-scheme: dark)').matches;
        if (savedTheme && ["dark", "light"].includes(savedTheme)) {
            setTheme(savedTheme);
        } else if (prefersDark) {
            setTheme("dark");
        }

        const savedCodeWrap = localStorage.getItem("code-wrapping") as string;

        if (savedCodeWrap === 'wrap') {
            setIsCodeWrapEnabled(false);
        } else {
            setIsCodeWrapEnabled(true);
        }
    }, []);


    return (
        <RecaptchaWrapper do_recaptcha={do_recaptcha}>
            <ThemeProvider theme={isDarkTheme ? darkTheme : lightTheme}>
                <>
                    <GlobalStyles isTransitionEnabled={isTransitionEnabled} isCodeWrapEnabled={isCodeWrapEnabled}/>
                    {do_sticky &&
                        <Sticky top={0} innerZ={9999} activeClass="nav-sticky">
                            <Navbar toggleTheme={toggleTheme}/>
                        </Sticky>
                    }
                    {children}
                    <ScrollToTop
                        showUnder={300}
                        duration={700}
                        easing="easeInOutCubic"
                        style={{bottom: 30, right: 20}}
                    >
                        <ScrollUpButton/>
                    </ScrollToTop>
                    {do_footy && <Footer/>
                    }
                </>
            </ThemeProvider>
        </RecaptchaWrapper>
    );
};

export default Layout;
